import { __assign, __extends } from "tslib";
import { namespacedClassnames } from '../../common';
import * as React from 'react';
import { calculateTextAreaSelection } from '../../common/user-input-commons';
export var deprecatedTextAreaKey = 'deprecated-text-area';
var defaultProps = {
    disabled: false,
};
/** @deprecated please use \<TextArea/> */
var DeprecatedTextArea = /** @class */ (function (_super) {
    __extends(DeprecatedTextArea, _super);
    function DeprecatedTextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            _this.props.onChange(e.target.value);
        };
        _this.onSelect = function (e) {
            if (_this.props.onSelect) {
                var t = e.target;
                var selection = calculateTextAreaSelection(t, _this.props.value);
                _this.props.onSelect(selection);
            }
        };
        return _this;
    }
    DeprecatedTextArea.prototype.render = function () {
        var partialProps = this.props;
        var props = __assign(__assign({}, defaultProps), partialProps);
        var classNames = namespacedClassnames(deprecatedTextAreaKey);
        return (React.createElement("textarea", { className: classNames, placeholder: props.placeholder, value: props.value, onChange: this.onChange, onSelect: this.onSelect, disabled: props.disabled, readOnly: props.readOnly, onBlur: props.onBlur, onKeyDown: props.onKeyDown }));
    };
    return DeprecatedTextArea;
}(React.Component));
export { DeprecatedTextArea };
//# sourceMappingURL=text-area.js.map